import PayButton from './PayButton';

export default {
  PayButton,
};
